import { initialCrudModelBaseState, CrudModelPaginatorLaboratory } from '@/shared/models/cruds.models'
import { AlarmType } from '@/modules/configurationModule/detail/notifications/models/alarms'
import { CommonLaboratoryResponse } from '@/api/services/common.dto'
import { alarmsGridColumnDefs } from '@/modules/configurationModule/detail/notifications/components/alarms-grid/alarms-grid.column-defs'
import { PaginatorLaboratoryDatasource } from '@/shared/resources/datasources/paginator/paginator-laboratory-datasource'
import { alarmNotificationConfigurationServices } from '@/modules/configurationModule/detail/notifications/services/alarm-notification-services'
import { store } from '@/store/store'

export interface ContentAlarmsGrid {
    id?: number,
    active: boolean,
    alarmType: AlarmType,
    associatedNotificationConfigurationId: number,
    cronExpression: string,
    customConfiguration: any,
    initialWindowInMinutes: number,
    laboratory: CommonLaboratoryResponse
}

export interface AlarmsGridState extends CrudModelPaginatorLaboratory<ContentAlarmsGrid> {
    laboratoryId: number
}
export const initialAlarmsGridState =
    (): AlarmsGridState => ({
        ...initialCrudModelBaseState(),
        gridUiComponent: 'uicomponent.configuration.local.notifications.alarmsGrid',
        columnsDef: alarmsGridColumnDefs([]),
        datasource: new PaginatorLaboratoryDatasource(alarmNotificationConfigurationServices, store.getters.labId),
        laboratoryId: store.getters.labId
    })
